export { SearchGlobal } from './SearchGlobal';
export type { SearchGlobalProps } from './SearchGlobal';
